
import * as React from 'react'
import { Button } from '@amzn/dvui/dist/Button'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { tryCatch } from '../../utils/tryCatch'
import * as utilityClasses from '../utilityClasses.module.scss'
import { ModalTrigger } from '@shared/utils/modalTrigger/ModalTrigger'
import { MwtwModal } from '../acquisition/moreWaysToWatchModal'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as st from '../acquisition/acquisition.module.scss'
import * as cn from 'classnames'
import { RecordRefTag } from '@utils'
import { ref } from '@amzn/dv-web-node-reftags'

export interface IATFMorePurchaseOptionProps extends AtfTreatmentProps {
  shouldShowMoreWaysToWatch: boolean
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
  titleId?: string
  toggleGiftCardModal?: () => void
}

export const AtfMorePurchaseOptions = tryCatch(
  ({
    shouldShowMoreWaysToWatch,
    moreWaysToWatch,
    titleId,
    toggleGiftCardModal,
    atfTreatment
  }: IATFMorePurchaseOptionProps) => {
    return shouldShowMoreWaysToWatch && titleId ? (
      <div
        className={`${utilityClasses.stretchHeight} ${utilityClasses.fullWidthPhablet}`}
      >
        <ModalTrigger
          size='m'
          modalId="dvui-close-overlay-atf-mwtw"
          modalContent={({ closeModal }) => (
            <MwtwModal
              closeModal={closeModal}
              moreWaysToWatch={moreWaysToWatch}
              toggleGiftCardModal={toggleGiftCardModal}
            />
          )}
          toggle={({ openModalClickHandler }) => (
            <RecordRefTag refTag={ref('atv_dp_mpo')}>
              <Button
                data-ux-click
                onClick={openModalClickHandler}
                name="more-purchase-options"
                {...(isTreatment(atfTreatment, 'T1', 'T3') && { shape: 'pill' })}
                className={cn({[st.centerButton]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')}, utilityClasses.fullWidth)}
              >
                <TextLocalizer stringID={StringId.DV_MWTW_TITLE_MAIN} />
              </Button>
            </RecordRefTag>
          )}
        />
      </div>
    ) : null
  }
)
